const { hostname } = window.location;
const environment =
  hostname.startsWith("www.dev.") ||
  hostname.startsWith("dev.") ||
  hostname === "localhost"
    ? "dev"
    : "prod";

export default environment;
